export default __webpack_public_path__ + "static/media/Michael2.c61e3ba4.png";